

const FileStorage = {
  state: {
    repo_id: '',
    repo_path: ''

  },
  mutations: {
    UPDATE_REPO: (state, payload) => {
      //
      state.repo_id = payload.repository_id
      state.repo_path = payload.repository_path

    }
    
  },
    
  getters: {
    repoId (state) {
      return state.repo_id
    },
    repoPath (state) {
      return state.repo_path
    }
  
  }
}
export default FileStorage
  